import { Helmet } from "react-helmet-async";
import { SITE_URL, SITE_NAME, HERO_IMAGE_URL, ORG_SCHEMA } from "@/lib/seo-config";

export function SEO({
  title,
  description,
  path = "",
  image,
  type = "website",
  schemas = [],
  breadcrumbs,
  noindex = false,
}) {
  const url = `${SITE_URL}${path}`;
  const ogImage = image || HERO_IMAGE_URL;

  const allSchemas = [ORG_SCHEMA, ...schemas];

  if (breadcrumbs) {
    allSchemas.push({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: breadcrumbs.map((bc, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: bc.name,
        item: `${SITE_URL}${bc.path}`,
      })),
    });
  }

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={SITE_NAME} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {allSchemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
